"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeWith = exports.remove = void 0;

var _has = require("../has/has");

var _isMatch = require("../is-match/is-match");

/**
 * Remove element(s) from array by value or by filter function
 *
 * @param  {Function|mixed}  value   Value to remove
 * @param  {Array}           source  Source array
 *
 * @return {Array}
 *
 * @tag Array
 * @signature (value: Function|mixed) => (source: Array): Array
 *
 * @example
 * remove(3)([1, 2, 3])
 * // => [1, 2]
 * remove(1, 3)([1, 2, 3])
 * // => [2]
 * remove(_ => _ === 3)([1, 2, 3])
 * // => [1, 2]
 */
var remove = function remove() {
  for (var _len = arguments.length, value = new Array(_len), _key = 0; _key < _len; _key++) {
    value[_key] = arguments[_key];
  }

  return function (source) {
    var result = [];

    for (var i = 0, length = source.length; i < length; i++) {
      var exists = typeof value[0] === "function" ? value[0].call(null, source[i]) === true : (0, _has.has)(source[i])(value);
      !exists && result.push(source[i]);
    }

    return result;
  };
};

exports.remove = remove;

var removeWith = function removeWith(subset) {
  return remove((0, _isMatch.isMatch)(subset));
};

exports.removeWith = removeWith;